let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ecJY3")).then(() => parcelRequire('azN9w'));